import React from "react";
import "./frontendDev.css";
import { Row, Col } from "antd";
import CardCourses from "../../../../utils/page/cards/index";
import { backendData } from "../../../../utils/coursesData/developerData/backendDeveloper";

const BackendDev = () => {
  return (
    <Row className="frontend_container">
      {backendData.map((frontendList) => {
        return (
          <Col
            key={frontendList.id}
            sm={{ span: 22 }}
            lg={{ span: 12 }}
            xl={{ span: 9 }}
          >
            <CardCourses
              img={frontendList.img}
              date={frontendList.date}
              urlLink={frontendList.urlLink}
              title={frontendList.title}
              subTitle={frontendList.subTitle}
              description={frontendList.description}
            />
          </Col>
        );
      })}
    </Row>
  );
};

export default BackendDev;
